import React, { Component } from 'react';
import { connect } from 'react-redux'; 
import { withTranslation } from 'react-i18next'; 
import SelectInput from 'screens/components/basic/SelectInput';
import AlpineSelect from 'screens/components/basic/AlpineSelect';
import GenericTable from 'screens/components/advanced/GenericTable';
import MaskedTextInputDiscount from 'screens/components/advanced/MaskedTextInputDiscount';
import DecimalInputDiscount from 'screens/components/basic/DecimalInputDiscount';
import { selectDiscountProducts } from 'selectors/entitySelector';
import { formInput, clearFormInput } from 'actions/FormActions';
import { alpineIQviewWallet } from 'actions/EntityActions';

class POSAlpineProductDiscount extends Component {

    constructor(props, context) {
        super(props, context);
    }

    inputDiscount = (discountid, productid, productOriginalPrice) => {
        if(discountid && this.props.wallet)
        {
            let discount = (this.props.wallet).find(x => x.id == discountid);
            if(discount)
            {
                let orderProductDiscountPoints = 0;
                if(this.props.posOrder && this.props.posOrder.products)
                {
                    this.props.posOrder.products.map((product) => {
                        orderProductDiscountPoints = orderProductDiscountPoints + product.alpineIQRewardPoints;
                    });
                }
        
                let orderDiscountPoints = 0;
                if(this.props.posOrder && this.props.posOrder.discounts)
                {
                    this.props.posOrder.discounts.map((odiscount) => {
                        orderDiscountPoints = orderDiscountPoints + odiscount.alpineIQRewardPoints;
                    });
                }

                if(this.props.alpineIQPoints - orderDiscountPoints - orderProductDiscountPoints < discount.pointsDeduction)
                {
                    alert(this.props.t('pos.alpineProductDiscount.unableToRedeemError'));
                    return;
                }

                if(discount.percentageValue > 0)
                {
                    this.props.formInput("Percentage", `${this.props.name}Type-${productid}`);
                    this.props.formInput(discount.percentageValue, `${this.props.name}Percentage-${productid}`);
                    this.props.formInput((productOriginalPrice * (1-discount.percentageValue/100.0)).toFixed(2), `${this.props.name}NewPrice-${productid}`)
                }
                else if(discount.dollarValue > 0)
                {
                    if(discount.type == 2)
                    {
                        if(discount.dollarValue > productOriginalPrice)
                        {
                            this.props.formInput(`${this.props.name}AlpineOptions-${productid}`);
                            alert(this.props.t('pos.alpineProductDiscount.discountCannotBeGreaterThanPrice'));
                            return;
                        }
                        this.props.formInput("Amount", `${this.props.name}Type-${productid}`);
                        this.props.formInput(discount.dollarValue.toFixed(2), `${this.props.name}Amount-${productid}`);
                        this.props.formInput((productOriginalPrice - discount.dollarValue).toFixed(2), `${this.props.name}NewPrice-${productid}`)
                    }
                    else if(discount.type == 3)
                    {
                        if(discount.dollarValue > productOriginalPrice)
                        {
                            this.props.clearFormInput(`${this.props.name}AlpineOptions-${productid}`);
                            alert(this.props.t('pos.alpineProductDiscount.oldPriceCheaperError'));
                            return;
                        }
                        if(this.props.products.find(x => x.id == productid).quantity > 1)
                        {
                            this.props.clearFormInput(`${this.props.name}AlpineOptions-${productid}`);
                            alert(this.props.t('pos.alpineProductDiscount.discountOnlyOnQuantOneItems'));
                            return;
                        }
                        this.props.formInput("Amount", `${this.props.name}Type-${productid}`);
                        this.props.formInput(productOriginalPrice-discount.dollarValue.toFixed(2), `${this.props.name}Amount-${productid}`);
                        this.props.formInput((discount.dollarValue).toFixed(2), `${this.props.name}NewPrice-${productid}`)
                    }
                }
                this.props.formInput(discount.redemptionURL || "", `${this.props.name}AlpineIQRedeemURL-${productid}`);
                this.props.formInput(discount.pointsDeduction || 0, `${this.props.name}AlpineIQRewardPoints-${productid}`);
            } 
        }
    }

    getProducts = () => {
        const types = [
            { text: this.props.t('pos.alpineProductDiscount.percentage'), value: 'Percentage' },
            { text: this.props.t('common.amount'), value: 'Amount' }
        ];
        const discounts = this.props.discounts;

        const data = this.props.products.filter(product => product.status === 1 && (product.discountType === null || (product.discountType == "Order" && this.props.alpineIQApiKey))).map((product) => {
            let discount = discounts.filter(item => product.id === item.productId)[0];

        const alpineKey = this.props.alpineIQApiKey;
        const alpineDiscounts = this.props.alpineDiscountOptions.length > 0;

        const handleChange = (e) => {
            this.inputDiscount(e, product.id, product.price);
          }

            return {
                Name: product.name,
                OriginalPrice: `${product.price.toFixed(2)}`,
                DiscountType: 
                    <SelectInput name={`${this.props.name}Type-${product.id}`}
                        underlineShow={false}
                        className="table-field smallFont"
                        label={this.props.t('pos.alpineProductDiscount.discountType')}
                        hintText={this.props.t('pos.alpineProductDiscount.discountType')}
                        style={{ width: '100%' }}
                        options={types} 
                        fullWidth={true}
                    />,
                DiscountAmount:
                    (discount)
                    ?
                    (discount.type === 'Percentage')
                    ?
                    <MaskedTextInputDiscount
                        underlineShow={true}
                        className="table-field"
                        fullWidth={true}
                        name={`${this.props.name}Percentage-${product.id}`}
                        label={this.props.t('common.discountPerc')}
                        hintText={this.props.t('common.discountPerc')}
                        mask="999"
                        min={0}
                        max={100}
                        originalPrice = {product.price.toFixed(2)} />
                    :
                    (discount.type === 'Amount') 
                    ?
                    <DecimalInputDiscount
                        name={`${this.props.name}Amount-${product.id}`}
                        underlineShow={true}
                        hintText={this.props.t('common.discountAmount')}
                        className="table-field"
                        fullWidth={true}
                        label={this.props.t('common.discountAmount')}
                        min={0}
                        max={product.price}
                        originalPrice = {product.price.toFixed(2)}
                        required />
                    :""
                    :"",
                
                NewPrice:
                        (discount)
                        ?
                        (discount.type === 'Percentage' || discount.type === 'Amount' ) 
                        ?
                        <DecimalInputDiscount
                            name={`${this.props.name}NewPrice-${product.id}`}
                            underlineShow={true}
                            hintText={this.props.t('pos.alpineProductDiscount.newPrice')}
                            className="table-field"
                            fullWidth={true}
                            label={this.props.t('pos.alpineProductDiscount.newPrice')}
                            min={0}
                            max={product.price}
                            originalPrice = {product.price.toFixed(2)}
                        />
                        :""
                        :"",
                AlpineIQDiscount: 
                        (alpineKey && alpineDiscounts)
                        ?
                        <AlpineSelect name={`${this.props.name}AlpineOptions-${product.id}`}
                            underlineShow={false}
                            label={this.props.t('pos.alpineProductDiscount.discountDown')}
                            hintText={this.props.t('pos.alpineProductDiscount.discountDown')}
                            style={{ width: '100%' }}
                            className="my-multi-lines-item"
                            options={this.props.alpineDiscountOptions} 
                            onChange={(e) => handleChange(e)}
                            fullWidth={true}
                        />
                        :""

            };  
        });

        return data;
    };

    render() {
        const { t } = this.props;
        return (
            <div>
                <div className="row">
                    <div className="col-lg-12">
                        <p>
                            {t('pos.alpineProductDiscount.enterDiscountTypeAmount')}
                        </p>
                        <GenericTable
                            compName="ProductsDiscountList"
                            columns={
                                [
                                    { key: "Name", label: t("common.name") },
                                    { key: "OriginalPrice", label: t("constants.originalPriceDollarSign") },
                                    { key: "DiscountType", label: t("pos.alpineProductDiscount.discountType") },
                                    { key: "DiscountAmount", label: t("pos.productDiscount.discountAmountText") },
                                    { key: "NewPrice", label: t("pos.productDiscount.newPriceIcon") },
                                    { key: "AlpineIQDiscount", label: t("constants.alpineIqDiscount") }
                                  ]
                            }
                            rows={this.getProducts() || []}
                            displaySelectAll={false}
                            adjustForCheckbox={false}
                            displayRowCheckbox={false}
                            multiSelectable={false}
                            enableSelectAll={false}
                            stripedRows={true}
                            selectable={false} />
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state, props) {
    let alpineDiscounts = state.entity.alpineIQwallet || [];
    let alpineDiscountOptions = [];
    alpineDiscounts.map((item) => {
        if(item.type == 2 || item.type == 3)
        {
            alpineDiscountOptions.push({
                text: item.name, value: item.id
            });
        }
    })
    return {
        products: state.entity.posOrder ? state.entity.posOrder.products : [],
        discounts: selectDiscountProducts(state.form, props.name, state.entity.priceMatchRows),
        alpineIQApiKey: state.common.applicationSettings.alpineIQApiKey || "",
        wallet: state.entity.alpineIQwallet,
        alpineDiscountOptions: alpineDiscountOptions,
        posOrder: state.entity.posOrder,
        branchId: state.common.branchId,
        alpineIQwalletCode: state.common.applicationSettings.alpineIQwalletCode || "",
        form: state.form
    };
}

function mapDispatchToProps(dispatch) {
    return {
        alpineIQviewWallet: (model) => dispatch(alpineIQviewWallet(model)),
        formInput: (value, name) => dispatch(formInput(value, name)),
        clearFormInput: (name) => dispatch(clearFormInput(name))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(POSAlpineProductDiscount));
